import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { Email } from './email.entity';
import { EmailStatus } from './email.status.enum';

export class CreateEmailDto extends Omit(Email, [...BaseEntityFieldsArray, 'status'], ['status']) {
    status?: EmailStatus;
}
